document.addEventListener("DOMContentLoaded", function () {
  function triggerSlickNav(link) {
    const parent = link.closest(".slicknav_parent");
    const arrow = parent ? parent.querySelector(".slicknav_arrow") : null;

    if (arrow) {
      arrow.click(); // 🔥 Trigger the actual SlickNav behavior
    }
  }

  function handleDropdownClicks(event) {
    if (window.innerWidth < 799) {
      const link = event.target.closest(".sub-menu--link");
      if (!link) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      triggerSlickNav(link);
    }
  }

  // Listen for text link clicks and trigger the real dropdown toggle
  document.body.addEventListener("click", handleDropdownClicks);
});


// document.addEventListener("DOMContentLoaded", function () {
//     // Select links inside dropdown sub-menus from the 2nd to 6th list items
//     let disabledLinks = document.querySelectorAll(".dropdown.sub-menu ul li:nth-child(n+2):nth-child(-n+6) a");

//     disabledLinks.forEach(link => {
//         link.removeAttribute("href"); // Remove link functionality
//         link.style.pointerEvents = "none"; // Disable interactions
//         link.style.cursor = "default"; // Remove pointer on hover
//         link.style.color = "gray"; // Optional: Make it visually disabled
//         link.style.textDecoration = "none"; // Remove underline for clarity

//         // Prevent default behavior if any JS re-adds href
//         link.addEventListener("click", function(event) {
//             event.preventDefault();
//             event.stopPropagation();
//         });
//     });
// });
